



















































































































































































import InputAmount from "../InputAmount.vue";
import { mapGetters } from "vuex";
import { i18n } from "@/plugins/i18n";
import PreviewAfbeelding from "@/components/PreviewAfbeelding.vue";
import TooltipPrijs from "@/components/TooltipPrijs.vue";
import { getTranslationMixin } from "@/mixins/getTranslationMixin";
import CurrencyFormat from "@/components/CurrencyFormat.vue";

export default {
  name: "DetailsBesteltips",
  components: {
    InputAmount,
    PreviewAfbeelding,
    TooltipPrijs,
    CurrencyFormat
  },
  mixins: [getTranslationMixin],
  props: {
    bestelTips: {
      type: Array,
      required: true
    }
  },
  computed: {
    ...mapGetters(["selectedLocationId", "getMultiSetting", "getIntSetting"]),
    hasLocation() {
      return this.$store.getters.selectedLocationId !== null;
    },
    showPriceInfo() {
      return this.$store.getters.showPrice;
    },
    showPreviewImage() {
      return this.getMultiSetting("Details_Besteltips_ShowPreviewImage");
    },
    showNummer() {
      return this.getMultiSetting("Details_Besteltips_ShowNummer");
    },
    showOmschrijving() {
      return this.getMultiSetting("Details_Besteltips_ShowOmschrijving");
    },
    showHuurprijs() {
      return this.getMultiSetting("Details_Besteltips_ShowHuurPrijs");
    },
    showDayPrice() {
      return this.getMultiSetting("Materieel_ShowDayPrice");
    },
    showWeekPrice() {
      return this.getMultiSetting("Materieel_ShowWeekPrice");
    },
    showVerkoopprijs() {
      return this.getMultiSetting("Details_Besteltips_ShowVerkoopPrijs");
    },
    showEenheid() {
      return this.getMultiSetting("Details_Besteltips_ShowEenheid");
    },
    showAanbevolenhoeveelheid() {
      return this.getMultiSetting("Details_Besteltips_ShowAanbevolenAantal");
    },
    showNummerArtikel() {
      return this.getMultiSetting("Details_Artikelen_ShowNummer");
    },
    showOmschrijvingArtikel() {
      return this.getMultiSetting("Details_Artikelen_ShowOmschrijving");
    },
    showHuurprijsArtikel() {
      return this.getMultiSetting("Details_Artikelen_ShowHuurPrijs");
    },
    showVerkoopprijsArtikel() {
      return this.getMultiSetting("Details_Artikelen_ShowVerkoopPrijs");
    },
    showEenheidArtikel() {
      return this.getMultiSetting("Details_Artikelen_ShowEenheid");
    },
    showAanbevolenhoeveelheidArtikel() {
      return this.getMultiSetting("Details_Artikelen_ShowAanbevolenAantal");
    }
  },
  methods: {}
};
